import { ActionIcon, Stack, Text } from '@mantine/core';
import { IconTrashX as DeleteIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface CriteriaItemDeleteButtonProps {
  index?: number;
  onRemove: () => void;
}

export function CriteriaItemDeleteButton({ index, onRemove }: CriteriaItemDeleteButtonProps) {
  const { t } = useTranslation();

  return (
    <Stack>
      {index != null && <Text fw="500">#{index + 1}</Text>}
      <ActionIcon
        mr="5px"
        onClick={onRemove}
        variant="filled"
        bg="red"
        aria-label={t('button.delete')}
      >
        <DeleteIcon
          style={{ width: '70%', height: '70%' }}
          stroke={1.5}
        />
      </ActionIcon>
    </Stack>
  );
}
